import React, { useEffect, useState, useContext } from 'react';
import MaskedInput from 'react-text-mask';
import * as S from './styles';
import { useLocation } from 'react-router-dom';

import { Api_Veiculos } from '../../services/FiltrosApi/veiculos_api';
import { Context } from '../../services/contexts/StateContext';

import { FunctModal, SetFunctions } from '../../componentes/Functions';

function ModalVeic() {
    const { state, dispatch } = useContext(Context);

    const { veiculo } = state.veiculo;
    const { franquia } = state.franquia;

    const { parametroInit, listaPesquisa, playmodal } = state.parametros;
    const { editModalVeic, detalhesVeic} = parametroInit;

    const localRota = useLocation();

    const { AtualizarVeiculo, AddPlaca } = Api_Veiculos();
    const { FecharModal } = FunctModal();
    const { SetVeiculo } = SetFunctions();

    //---------------------------------------------------

    const [paginaCotacao, setpaginaCotacao] = useState(false);

    useEffect(() => {
        if (localRota.pathname === "/cotacao") {
            setpaginaCotacao(true);
        }
    }, []);

    const setVeiculoUpper = (key, value, maxLength) => {
        const valor = (value || '').toUpperCase().slice(0, maxLength);
        SetVeiculo(key, valor);
    };

    const setVeiculoNumber = (key, value, maxLength) => {
        const valor = (value || '').replace(/\D/g, '').slice(0, maxLength);
        SetVeiculo(key, valor);
    };

    const setVeiculoDecimal = (key, value) => {
        const valor = (value || '').replace(',', '.');
        SetVeiculo(key, valor);
    };
    //---------------------------------------------------
    useEffect(() => {
        dispatch({
            type: 'SET_Franquia',
            payload: { ...franquia, id: veiculo.id_Franquia }
        });
    }, [veiculo.id_Franquia])
    //-------------------------------------------

    function Atualizar() {
        dispatch({
            type: 'SET_parametroInit',
            payload: {
                ...parametroInit,
                disabled: false,
                editModal: true,
            }
        });
    };
    // -------------------------------------------
    useEffect(() => {
        if (veiculo.id_Veiculo) {
            dispatch({
                type: 'SET_parametroInit',
                payload: {
                    ...parametroInit,
                    disabled: true
                }
            });
        }
    }, [veiculo.id_Veiculo]);

    // --------------------------------

    const [valor, setvalor] = useState('');

    const FormatDecimal = (e) => {
        let rawValue = e.target.value.replace(/\D/g, ''); // Remove não-números
        if (rawValue.length === 0) {
            setvalor('0,00');
            return;
        }
        
        // Converte para número e divide por 100
        let numericValue = Number(rawValue) / 100;
        
        // Formata como PT-BR
        let formattedValue = numericValue.toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
        
        setvalor(formattedValue);
        SetVeiculo('valorFipe', numericValue); // Armazena o valor numérico com vírgula
    };
    // ------------------------

    async function SalvarPlaca() {
        const resposta = await AddPlaca();
        console.log(resposta)
        if (resposta._id) {
            dispatch({
                type: 'set_veiculo',
                payload: {
                    ...veiculo,
                    id_Veiculo: resposta._id,
                    id_ClienteVeiculo: resposta?.id_Cliente?._id || "",
                    tipo: resposta?.tipo,
                    placa: resposta?.placa,
                    modelo: resposta?.modelo,
                    anoMod: resposta?.anoMod,
                    cor: resposta?.cor,
                    marca: resposta?.marca,
                    valorFipe: resposta?.valorFipe,
                    situacao: resposta?.situacao,
                }
            });

            dispatch({
                type: 'SET_PLAYMODAL',
                payload: {
                    ...playmodal,
                    playModalVeiculo: false,
                    playModalEven: false,
                    playModalEvenPlaca: true,

                }
            });

            dispatch({
            type: 'SET_parametroInit',
            payload: {
                ...parametroInit,
                NaoLocalizado: false,
            }
        });
        } else {
            alert("Ocorreu um erro ao adicionar a placa. Tente novamente.");
        }
    }
    

    //###################################################################################

    return (
        <S.body
            detalhesLista={parametroInit.detalhesLista}
            editModal={parametroInit.editModal}
        >
            <S.Container>
                <S.div3>
                    <div className='titulo'>
                        <div className={'tituloUser'}>
                            <span>{detalhesVeic ? 'Detalhes Veiculo' : editModalVeic ? 'EDITAR Veiculo' : 'Novo Veiculo'}</span>
                        </div>
                        <div
                            className='fechar'
                            onClick={() => {FecharModal()}}>X
                        </div>
                    </div>
                </S.div3>

                <S.div3>
                    {/* ----------------------------------- */
                    !paginaCotacao &&
                    <S.box1>
                        <div>
                            <span>Regional:</span>
                            <select
                                value={veiculo.id_Franquia}
                                onChange={e => SetVeiculo('id_Franquia', e.target.value)}
                                required>
                                <option value=''>Selecione</option>
                                {listaPesquisa.listaFranquia.map((s, key) =>
                                    <option key={key} value={s.value}>{s.label}</option>
                                )}
                            </select>
                        </div>
                        {/* <div>
                            <span>Colaborador:</span>
                            <select
                                value={veiculo.id_Colaborador}
                                onChange={e => SetVeiculo('id_Colaborador', e.target.value)}
                                required>
                                <option></option>
                                {listaColaborador.map((s, key) =>
                                    <option key={key} value={s.value}>{s.label}</option>
                                )}
                            </select>
                        </div> */}
                    </S.box1>
                    }
                    <S.box1>
                        <div>
                            <span>Tipo de Veiculo:</span>
                            <select
                                value={veiculo.id_Tipo}
                                onChange={e => SetVeiculo('tipo', e.target.value)}
                                required>
                                <option>{veiculo.tipo.toUpperCase() || ''}</option>
                                <option value="automovel">AUTOMÓVEL</option>
                                <option value="motocicleta">MOTOCICLETA</option>
                                <option value="caminhao">CAMINHÃO</option>
                            </select>
                        </div>
                        <div>
                            <span>Placa:</span>
                            <MaskedInput
                                value={veiculo.placa}
                                className='uppercase'
                                type='text'
                                placeholder='ABC1D23'
                                mask={[/\D/, /\D/, /\D/, /\d/, /\w/, /\d/, /\d/]}
                                onChange={e => setVeiculoUpper('placa', e.target.value, 7)}
                                autoComplete='off'
                                guide={false}
                            />
                        </div>
                    </S.box1>

                    {
                    !paginaCotacao &&
                    <S.box1>
                        <div style={{ minWidth: "150px" }}>
                            <span>Chassi:</span>
                            <input
                                value={veiculo.chassi}
                                className='uppercase'
                                type='text'
                                placeholder='Chassi'
                                maxLength={17}
                                autoComplete='off'
                                onChange={e => setVeiculoUpper('chassi', e.target.value, 17)}
                            />
                        </div>
                        <div style={{ minWidth: "180px" }}>
                            <span>Numero Motor:</span>
                            <input
                                value={veiculo.n_motor}
                                className='uppercase'
                                type='text'
                                placeholder='Número do motor'
                                maxLength={21}
                                autoComplete='off'
                                onChange={e => setVeiculoUpper('n_motor', e.target.value, 21)}
                            />
                        </div>

                        <div style={{ minWidth: "150px" }}>
                            <span>Renavam:</span>
                            <input
                                value={veiculo.renavam}
                                className='uppercase'
                                type='text'
                                inputMode='numeric'
                                maxLength={11}
                                placeholder='Apenas números'
                                autoComplete='off'
                                onChange={e => setVeiculoNumber('renavam', e.target.value, 11)}
                            />
                        </div>
                    </S.box1>
                    }

                    <S.box1>
                        <div>
                            <span>Marca:</span>
                            <input
                                value={veiculo.marca}
                                className='maiusculo'
                                type='text'
                                placeholder='Marca'
                                maxLength={40}
                                autoComplete='off'
                                onChange={e => setVeiculoUpper('marca', e.target.value, 40)}
                            />
                        </div>
                        <div>
                            <span>Modelo:</span>
                            <input
                                value={veiculo.modelo}
                                className='maiusculo'
                                type='text'
                                placeholder='Modelo'
                                maxLength={50}
                                autoComplete='off'
                                onChange={e => setVeiculoUpper('modelo', e.target.value, 50)}
                            />
                        </div>
                    </S.box1>

                    <S.box1>
                        <div style={{flex: 0.6}}>
                            <span>Ano Modelo:</span>
                            <MaskedInput
                                value={veiculo.anoMod}
                                type='text'
                                placeholder='Ano Modelo'
                                mask={[/\d/, /\d/, /\d/, /\d/]}
                                inputMode='numeric'
                                onChange={e => setVeiculoNumber('anoMod', e.target.value, 4)}
                                guide={false}
                            />
                        </div>
                        <div style={{flex: 0.6}}>
                            <span>Cor:</span>
                            <input
                                value={veiculo.cor}
                                className='maiusculo'
                                type='text'
                                placeholder='Cor'
                                maxLength={20}
                                autoComplete='off'
                                onChange={e => setVeiculoUpper('cor', e.target.value, 20)}
                            />
                        </div>

                        {paginaCotacao &&
                        <div>
                            <span>Valor FIPE:</span>
                            <input
                                type="text"
                                value={valor || veiculo.valorFipe}
                                onChange={FormatDecimal}
                                placeholder="0.00"
                            />
                        </div>
                        }
                    </S.box1>

                    <S.divButton editModal={parametroInit.editModal}>
                        {!veiculo.id_Veiculo ?
                            <S.Salvar>
                                <button type='button' onClick={SalvarPlaca}>
                                    Salvar
                                </button>
                            </S.Salvar>
                            :
                            veiculo.id_Veiculo && parametroInit.editModal ?
                                <S.Salvar>
                                    <button type='button' onClick={AtualizarVeiculo}>
                                        Atualizar 
                                    </button>
                                </S.Salvar>
                                :
                                <S.Atualizar>
                                    <button
                                        type='button'
                                        style={{ backgroundColor: "#ffbf00" }}
                                        onClick={Atualizar}>
                                        EDITAR
                                    </button>
                                </S.Atualizar>
                        }
                    </S.divButton>
                </S.div3>
            </S.Container>
        </S.body >
    );
}

export default ModalVeic;
